import { createFileRoute } from '@tanstack/react-router'
import { NewGroupDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditGroupDialog from '@/routes/_app/-dialogs/edit-group'

export const Route = createFileRoute('/@modal/groups/new')({
  staticData: { slotScope: '/_app/orgs' },
  pendingComponent: NewGroupDialogPending,
  component: NewGroupSlot,
})

function NewGroupSlot() {
  const slot = useModalSlot(Route)
  return <EditGroupDialog {...slot} />
}
